import { Component, Input, OnInit } from '@angular/core';
import { WebsiteBuilderItemAbout, WebsiteBuilderItemWelcomeMessage } from '../../../../../types/website-builder/items';

@Component({
    selector: 'wb-edit-about',
    templateUrl: './wb-edit-about.component.html',
    styleUrls: [
        '../../website-builder-side-editor.component.scss',
        './wb-edit-about.component.scss'
    ]
})
export class WbEditAboutComponent implements OnInit {

    @Input() pageData: WebsiteBuilderItemAbout | WebsiteBuilderItemWelcomeMessage;

    constructor() {
    }

    ngOnInit() {
    }

    get isShowImage() {
        return this.pageData instanceof WebsiteBuilderItemAbout;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/section/wb-edit-about/wb-edit-about.component.ts